import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Users } from "lucide-react";
import { ABOUT } from "./psoData";
import PsoLayout, { NAVY, EMERALD, CREAM, SLATE } from "./PsoLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function PsoAbout() {
  const tagalog = typeof window !== "undefined" && window.localStorage.getItem("mysitecare-language") === "tl";
  return (
    <PsoLayout active="about">
      <section className="py-16 sm:py-20" style={{ background: NAVY }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#6EE7B7" }}>About</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">{tagalog ? `Itinayo ni ${ABOUT.founder}` : `Built by ${ABOUT.founder}`}</motion.h1>
        </div>
      </section>

      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 space-y-6">
          <motion.div {...fadeUp} className="bg-white rounded-lg p-6 shadow-sm">
            <h3 className="font-bold text-sm uppercase tracking-wide mb-2" style={{ color: EMERALD }}>The Story</h3>
            <p className="text-sm" style={{ color: SLATE }}>{ABOUT.story}</p>
          </motion.div>
          <motion.div {...fadeUp} className="bg-white rounded-lg p-6 shadow-sm flex items-start gap-3">
            <Users size={20} style={{ color: EMERALD }} className="shrink-0 mt-0.5" />
            <p className="text-sm" style={{ color: SLATE }}>{ABOUT.clients}</p>
          </motion.div>
          <motion.div {...fadeUp} className="flex items-start gap-2.5 rounded-lg p-4 text-xs bg-white">
            <ShieldCheck size={16} className="shrink-0 mt-0.5" style={{ color: EMERALD }} />
            {ABOUT.affiliations}
          </motion.div>
        </div>
      </section>
    </PsoLayout>
  );
}
